// apps/vendor/src/features/announcements/icons.tsx
//
// Inline SVG glyphs for the announcement banner/carousel. The vendor SPA
// deliberately avoids lucide-react (it pulls a full icon bundle for a
// handful of strokes — see VendorSidebar comment); these mirror the lucide
// paths used by the merchant-v3 announcement components so the two portals
// look identical.

import type { JSX } from 'react';

interface IconProps {
  className?: string;
}

function svg(children: JSX.Element, className?: string): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className ?? 'h-4 w-4'}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function AlertTriangleIcon({ className }: IconProps): JSX.Element {
  return svg(
    <>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </>,
    className,
  );
}

export function PercentIcon({ className }: IconProps): JSX.Element {
  return svg(
    <>
      <line x1="19" y1="5" x2="5" y2="19" />
      <circle cx="6.5" cy="6.5" r="2.5" />
      <circle cx="17.5" cy="17.5" r="2.5" />
    </>,
    className,
  );
}

export function SparklesIcon({ className }: IconProps): JSX.Element {
  return svg(
    <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z" />,
    className,
  );
}

export function ClockIcon({ className }: IconProps): JSX.Element {
  return svg(
    <>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </>,
    className,
  );
}

export function MegaphoneIcon({ className }: IconProps): JSX.Element {
  return svg(
    <>
      <path d="m3 11 18-5v12L3 14v-3z" />
      <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </>,
    className,
  );
}

export function XIcon({ className }: IconProps): JSX.Element {
  return svg(
    <>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </>,
    className,
  );
}

export function ChevronLeftIcon({ className }: IconProps): JSX.Element {
  return svg(<polyline points="15 18 9 12 15 6" />, className);
}

export function ChevronRightIcon({ className }: IconProps): JSX.Element {
  return svg(<polyline points="9 18 15 12 9 6" />, className);
}
